<template>
  <div style="height: 100%;background-color: white">服务工单</div>
</template>

<script>
export default {
  name: 'serviceWorkOrder'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/serviceWorkOrder.vue